import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { FLOAT } from "@/constants/testIds";

export const FloatingWhatsApp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 240);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="https://wa.me/919959133388?text=Hi%20Transformo%2C%20I%27d%20like%20to%20discuss%20a%20mandate."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid={FLOAT.whatsapp}
      className={`fixed z-50 bottom-6 right-6 group flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white px-5 py-4 float-whatsapp transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <MessageCircle className="w-5 h-5" />
      <span className="text-sm font-semibold hidden sm:inline">
        WhatsApp 9959133388
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
